export const getLabel = (array, value) => {
    for (let i = 0; i < array.length; i++) {
        if (array[i].value == value) {
            return array[i].label
        }
    }
}